import React, { useEffect, useState } from 'react';
import { useGalleryUI } from '../../../context/GalleryContext';
const galleryUiComponents = {
    videoPlayButton: React.lazy(() => import(/* webpackChunkName: "defaultPlayButton" */ './playButton')),
    rotateArrow: React.lazy(() => import(/* webpackChunkName: "defaultRotateArrow" */ './rotateArrow')),
};
export const GalleryUI = ({ type, size }) => {
    const [isMounted, setIsMounted] = useState(false);
    const galleryUI = useGalleryUI();
    useEffect(() => {
        setIsMounted(true);
    }, []);
    if (!isMounted) {
        return React.createElement(React.Fragment, null);
    }
    if (typeof (galleryUI === null || galleryUI === void 0 ? void 0 : galleryUI[type]) === 'function') {
        return galleryUI[type](size);
    }
    const Component = galleryUiComponents[type];
    if (!Component) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(Component, { size: size })));
};
//# sourceMappingURL=GalleryUI.js.map